import router from "../router";
import cookie from "@/utils/store/cookie";
import { isWeixin } from "@/utils";
import { oAuth } from "@/libs/wechat";

export default function toLogin(name, fullPath, push, backUrl) {
  // console.log(router.currentRoute,122000)
  // const { fullPath, name } = router.currentRoute;
  cookie.set("login_back_url", backUrl || fullPath);
  if (isWeixin()) {
    oAuth();
  } else {
    if (name !== "mobileLogin") {
      push ? router.push({ path: "/mobileLogin" }) : router.push({ path: "/mobileLogin" });
    }
  }
}



// WEBPACK FOOTER //
// ./src/libs/login.js